module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/banner_movie-ee5cd19a0f09ff9ab308002e030bfbb9.webp";